import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IForm } from '@fi-shared/fi-form-shared/fi-form-shared';
import { FiItemsListHelperService } from '@fi-shared/fi-items-list/fi-items-list-helper.service';

@Component({
    selector: 'fi-form-list-extended-search',
    template: ` <fi-form-list
        [extendedSearchMode]="true"
        (selectionChanged)="onSelectionChanged($event)"
    ></fi-form-list>`,
    styleUrls: ['./fi-form-list-extended-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-list-extended-search' },
    standalone: false,
})
export class FiFormListExtendedSearchComponent {
    constructor(private itemsListHelperService: FiItemsListHelperService) {}

    onSelectionChanged($event: IForm[]) {
        this.itemsListHelperService.triggerExtendedSearchSelectionChanged($event);
    }
}
